export default __webpack_public_path__ + "static/media/table2.ebe642de.svg";